// @ts-nocheck

import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NewTransfer } from '../model';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import 'rxjs/add/operator/take'

@Component({
  selector: 'app-new-transfer',
  templateUrl: './new-transfer.component.html',
  styleUrls: ['./new-transfer.component.css']
})
export class NewTransferComponent implements OnInit {

  transfer = new NewTransfer(0, "HEK", "", "")
  @Output() created = new EventEmitter();
  loading = false
  error = false

  constructor(public db: AngularFireDatabase, auth: AngularFireAuth) {
    let userId = auth.auth.currentUser.uid
    this.transfer.fromUser = userId
    // Select currency with highest balance
    this.db.object("balances/" + userId).valueChanges().take(1).subscribe(
      balances => {
        let max = Math.max(balances["HEK"], balances["TBR"], balances["RND"])
        if (max == balances["HEK"]) {
          this.transfer.currency = "HEK"
        } else if (max == balances["TBR"]) {
          this.transfer.currency = "TBR"
        } else if (max == balances["RND"]) {
          this.transfer.currency = "RND"
        }
      }
    )
  }

  ngOnInit() {
  }

  currencyChanged(currency) {
    this.transfer.currency = currency
  }

  onSubmit() {
    this.loading = true
    this.error = false
    var transferId = this.db.list("transfers").push(this.transfer).key
    this.db.object("transfers/" + transferId + "/validated").valueChanges().subscribe(
      value => {
        if (value == true) {
          this.created.emit()
        }
      }
    )
    this.db.object("transfers/" + transferId).valueChanges().subscribe(
      value => {
        if (value == null) {
          this.error = true
          this.loading = false
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/new-transfer/new-transfer.component.ts